import Grid from './src/grid.vue';
import GridItem from './src/grid-item.vue';
import { SFCWithInstall } from '@touchvue/utils';
export declare const ToGrid: SFCWithInstall<typeof Grid>;
export declare const ToGridItem: SFCWithInstall<typeof GridItem>;
export default ToGrid;
export * from './src/instance';
